import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column min-h-screen" }
const _hoisted_2 = { class: "flex-1" }

import MainNavbar from "@/views/MainNavbar.vue"
import MainFooter from "@/views/MainFooter.vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_p_toast = _resolveComponent("p-toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MainNavbar),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(MainFooter)
    ]),
    _createVNode(_component_p_toast, {
      position: "top-right",
      "auto-z-index": false,
      "base-z-index": 10,
      style: {"z-index":"99999"}
    })
  ], 64))
}
}

})